import type { FeedItem as FeedItemType } from '@whispers/sdk';

import { Button } from '../Button.js';
import { FeedItem } from './FeedItem.js';

type NoteFeedItemProps = { item: Extract<FeedItemType, { type: 'note' }> };

export const NoteFeedItem = ({ item }: NoteFeedItemProps) => (
  <FeedItem label={item.reading ? 'Reading reflection' : 'Note'} occurredAt={item.occurredAt}>
    <p className="whitespace-pre-wrap text-sm leading-7 text-text">{item.note.content}</p>
    {item.reading && (
      <Button href={`/readings/${item.reading.id}`} variant="secondary" className="mt-5 w-full">
        View full reading
      </Button>
    )}
  </FeedItem>
);
